module.exports = __webpack_public_path__ + "img/img-buy-online-2.c24c53f4.svg";